<template>
    <div>
        <ag-grid-vue
            class="ag-theme-material"
            :style="style"
            :grid-options="gridOptions"
            @grid-ready="onGridReady"
            :column-defs="columnDefs"
        >
        </ag-grid-vue>
    </div>
</template>

<script>
export default {
    props: {
        columnDefsEntrypoint: {required: true},
        rowDataEntrypoint: {required: true},
    },
    data: () => ({
        rowData: [],
        columnDefs: [],
        gridOptions: {
            pagination: true,
            paginationPageSize: 10,
            cacheBlockSize: 10,
            rowModelType: 'serverSide',
        },
        style: {
            width: '1280px',
            height: '592px',
        },
        getRowsParams: null,
    }),
    created() {
        this.getColumnsDefs()
        this.getRowData()
    },
    methods: {
        getColumnsDefs() {
            this.$jmp.bff(this, this.columnDefsEntrypoint)
        },
        getRowData() {
            this.$jmp.bff(this, this.rowDataEntrypoint)
        },
        onGridReady(params) {
            params.api.setServerSideDatasource(this.datasource());
        },
        refreshData() {
            this.$jmp.bff(this, this.rowDataEntrypoint, this.getRowsParams.params)
                .then(response => {
                    this.getRowsParams.successCallback(response.data)
                    this.getRowsParams.api.redrawRows();
                })
                .catch(error => params.failCallback())
        },
        datasource() {
            return {
                getRows: (getRowsParams) => {
                    this.$set(this, 'getRowsParams', getRowsParams)
                    this.refreshData()
                },
                refresh: () => {
                    this.refreshData()
                },
            }
        },
    },
}
</script>
